var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrSelect',{attrs:{"value":_vm.value,"items":_vm.mimeTypes,"loading":_vm.loading,"rules":_vm.rules,"item-text":"name","item-value":"mimeType","multiple":"","return-object":"","label":"Mime Types","searchable":"","required":""},on:{"change":_vm.onValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }